export enum Locale {
  en_ZZ = 'en_ZZ',
  es_ZZ = 'es_ZZ',
  de_DE = 'de_DE',
  de_AT = 'de_AT',
  en_AT = 'en_AT',
  de_CH = 'de_CH',
  en_DE = 'en_DE',
  fr_CH = 'fr_CH',
  it_CH = 'it_CH',
  en_CH = 'en_CH',
  nl_NL = 'nl_NL',
  en_NL = 'en_NL',
  nl_BE = 'nl_BE',
  fr_BE = 'fr_BE',
  pl_PL = 'pl_PL',
  cs_CZ = 'cs_CZ',
  sk_SK = 'sk_SK',
  ro_RO = 'ro_RO',
  hu_HU = 'hu_HU',
  sl_SI = 'sl_SI',
  lv_LV = 'lv_LV',
  ru_LV = 'ru_LV',
  lt_LT = 'lt_LT',
  et_EE = 'et_EE',
  ru_EE = 'ru_EE',
  hr_HR = 'hr_HR',
  bg_BG = 'bg_BG',
  da_DK = 'da_DK',
  fr_FR = 'fr_FR',
  sv_SE = 'sv_SE',
  fi_FI = 'fi_FI',
  es_ES = 'es_ES',
  it_IT = 'it_IT',
  pt_PT = 'pt_PT',
  el_GR = 'el_GR',
  el_CY = 'el_CY',
  fr_LU = 'fr_LU',
}

export type THrefLang =
  | 'de-DE'
  | 'en-DE'
  | 'de-AT'
  | 'en-AT'
  | 'de-CH'
  | 'fr-CH'
  | 'it-CH'
  | 'en-CH'
  | 'pl-PL'
  | 'cs-CZ'
  | 'nl-NL'
  | 'en-NL'
  | 'nl-BE'
  | 'fr-BE'
  | 'ro-RO'
  | 'hu-HU'
  | 'sk-SK'
  | 'sl-SI'
  | 'lv-LV'
  | 'ru-LV'
  | 'lt-LT'
  | 'et-EE'
  | 'ru-EE'
  | 'hr-HR'
  | 'bg-BG'
  | 'fr-FR'
  | 'da-DK'
  | 'sv-SE'
  | 'fi-FI'
  | 'es-ES'
  | 'it-IT'
  | 'pt-PT'
  | 'el-GR'
  | 'fr-LU';

export type THrefLangByLocale = {
  locale: Locale;
  hrefLang: THrefLang;
};

export type CountryOf<ThisLocale extends Locale> =
  ThisLocale extends `${string}_${infer Country}` ? Country : never;

export type LanguageOf<ThisLocale extends Locale> =
  ThisLocale extends `${infer Language}_${string}` ? Language : never;

export type AnyCountry = CountryOf<Locale>;
export type AnyLanguage = LanguageOf<Locale>;

export function getCountry<SpecificLocale extends Locale>(
  locale: SpecificLocale,
) {
  return locale.split('_')[1]! as CountryOf<SpecificLocale>;
}

export function getLanguage<SpecificLocale extends Locale>(
  locale: SpecificLocale,
) {
  return locale.split('_')[0]! as LanguageOf<SpecificLocale>;
}

enum HelpCenterLocale {
  bg = 'bg',
  cs = 'cs',
  da = 'da',
  de = 'de',
  de_at = 'de-at',
  en_at = 'en-at',
  it_ch = 'it-ch',
  de_ch = 'de-ch',
  en_ch = 'en-ch',
  en_de = 'en-de',
  en_001 = 'en-001',
  da_DK = 'en-dk',
  sv_SE = 'en-se',
  en_us = 'en-us',
  es_es = 'es-es',
  es = 'es',
  et = 'et',
  ru_ee = 'ru-ee',
  fi = 'fi',
  fr = 'fr',
  fr_be = 'fr-be',
  fr_ch = 'fr-ch',
  fr_fr = 'fr-fr',
  ga = 'ga',
  hr = 'hr',
  hu = 'hu',
  hu_hu = 'hu-hu',
  it = 'it-it',
  lt = 'lt',
  lv = 'lv',
  ru_lv = 'ru-lv',
  nl = 'nl',
  en_nl = 'en-nl',
  nl_be = 'nl-be',
  pl = 'pl',
  ro = 'ro',
  sk = 'sk',
  sl = 'sl',
  sv = 'sv',
  pt = 'pt-pt',
  gr = 'el-gr',
  el_cy = 'el-cy',
  fr_lu = 'fr-lu',
}

export const localeToHCLocale: Record<Locale, HelpCenterLocale> = {
  en_ZZ: HelpCenterLocale.en_001,
  es_ZZ: HelpCenterLocale.es,
  de_DE: HelpCenterLocale.de,
  de_AT: HelpCenterLocale.de_at,
  en_AT: HelpCenterLocale.en_at,
  de_CH: HelpCenterLocale.de_ch,
  fr_CH: HelpCenterLocale.fr_ch,
  it_CH: HelpCenterLocale.it_ch,
  en_CH: HelpCenterLocale.en_ch,
  en_DE: HelpCenterLocale.en_de,
  nl_NL: HelpCenterLocale.nl,
  en_NL: HelpCenterLocale.en_nl,
  nl_BE: HelpCenterLocale.nl_be,
  fr_BE: HelpCenterLocale.fr_be,
  pl_PL: HelpCenterLocale.pl,
  cs_CZ: HelpCenterLocale.cs,
  sk_SK: HelpCenterLocale.sk,
  ro_RO: HelpCenterLocale.ro,
  hu_HU: HelpCenterLocale.hu,
  sl_SI: HelpCenterLocale.sl,
  lv_LV: HelpCenterLocale.lv,
  ru_LV: HelpCenterLocale.ru_lv,
  lt_LT: HelpCenterLocale.lt,
  et_EE: HelpCenterLocale.et,
  ru_EE: HelpCenterLocale.ru_ee,
  hr_HR: HelpCenterLocale.hr,
  bg_BG: HelpCenterLocale.bg,
  da_DK: HelpCenterLocale.da,
  fr_FR: HelpCenterLocale.fr,
  sv_SE: HelpCenterLocale.sv,
  fi_FI: HelpCenterLocale.fi,
  es_ES: HelpCenterLocale.es_es,
  it_IT: HelpCenterLocale.it,
  pt_PT: HelpCenterLocale.pt,
  el_GR: HelpCenterLocale.gr,
  el_CY: HelpCenterLocale.el_cy,
  fr_LU: HelpCenterLocale.fr_lu,
};

export const localeToKlarnaOsmLocale: Record<Locale, string | undefined> = {
  en_ZZ: undefined,
  es_ZZ: undefined,
  de_DE: 'de-DE',
  de_AT: undefined,
  en_AT: undefined,
  de_CH: undefined,
  fr_CH: undefined,
  it_CH: undefined,
  en_CH: undefined,
  en_DE: 'en-DE',
  nl_NL: undefined,
  en_NL: undefined,
  nl_BE: undefined,
  fr_BE: undefined,
  pl_PL: 'pl-PL',
  cs_CZ: 'cs-CZ',
  sk_SK: 'sk-SK',
  ro_RO: 'ro-RO',
  hu_HU: 'hu-HU',
  sl_SI: undefined,
  lv_LV: undefined,
  ru_LV: undefined,
  lt_LT: undefined,
  et_EE: undefined,
  ru_EE: undefined,
  hr_HR: undefined,
  bg_BG: undefined,
  da_DK: 'da-DK',
  fr_FR: 'fr-FR',
  sv_SE: 'sv-SE',
  fi_FI: 'fi-FI',
  es_ES: 'es-ES',
  it_IT: 'it-IT',
  pt_PT: 'pt-PT',
  el_GR: 'el-GR',
  el_CY: undefined,
  fr_LU: undefined,
};
